import { render, staticRenderFns } from "./ShippingDetailsComponent.vue?vue&type=template&id=95fd4444"
import script from "./ShippingDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ShippingDetailsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports